var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "@drklein/client-detection", "@drklein/locale-formatter", "jquery", "jquery-ui/ui/widgets/datepicker"], function (require, exports, client_detection_1, LocaleFormatter) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    LocaleFormatter = __importStar(LocaleFormatter);
    $(function () {
        if ($(".forwardKurzrechner2023").length === 0) {
            return;
        }
        var now = new Date();
        var dateAtLastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        var $dateInputField = $(".forwardKurzrechner2023_dateInputField");
        function setInputFieldValue(value) {
            $dateInputField.prop("value", value);
        }
        function addAriaLabelToDatepickerTrigger(retries, delay) {
            if (retries === void 0) { retries = 10; }
            if (delay === void 0) { delay = 100; }
            var $trigger = $(".ui-datepicker-trigger");
            if ($trigger.length > 0) {
                $trigger.attr("aria-label", "Datum auswählen");
            }
            else if (retries > 0) {
                setTimeout(function () { return addAriaLabelToDatepickerTrigger(retries - 1, delay); }, delay);
            }
        }
        if (client_detection_1.MobileDetection.isMobile()) {
            setInputFieldValue("".concat(dateAtLastDayOfMonth.getFullYear(), "-").concat(dateAtLastDayOfMonth.getMonth() + 1, "-").concat(dateAtLastDayOfMonth.getDate()));
        }
        else {
            var currentYear = now.getFullYear();
            $dateInputField.datepicker("option", {
                minDate: now,
                yearRange: "".concat(currentYear, ":").concat(currentYear + 5),
            });
            addAriaLabelToDatepickerTrigger();
            setInputFieldValue(LocaleFormatter.dateAsGermanLocaleDateString(dateAtLastDayOfMonth));
        }
    });
});
